import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> { error?: boolean; }
const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, error, children, ...props }, ref) => (
  <select ref={ref} className={cn('flex h-10 w-full rounded-lg border bg-white px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:opacity-50', error ? 'border-red-500' : 'border-slate-300', className)} {...props}>{children}</select>
));
Select.displayName = 'Select';
export { Select };
